<template>
  <div ref="stickyContainer">
    <div ref="stickyElement" :class="{ 'fixed inset-x-0 bottom-0 z-20 bg-background px-5': isSticky }">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBreakpoint } from '~/composables/breakpoint'

const isSticky = ref(false)
const stickyElement = useTemplateRef('stickyElement')
const stickyContainer = useTemplateRef('stickyContainer')
const { isBreakpoint } = useBreakpoint()
const isBreakpointMd = isBreakpoint('md')

const onScroll = () => {
  if (isBreakpointMd.value) {
    isSticky.value = false
  } else if (stickyElement.value && stickyContainer.value) {
    if (isSticky.value) {
      const elementTop = window.scrollY + stickyElement.value.getBoundingClientRect().top
      const targetPosition = window.scrollY + stickyContainer.value.getBoundingClientRect().top

      isSticky.value = targetPosition < elementTop
    } else {
      const elementBottom = window.scrollY + stickyElement.value.getBoundingClientRect().bottom
      const windowBottom = window.scrollY + window.innerHeight

      isSticky.value = windowBottom >= elementBottom
    }
  }
}

onMounted(() => {
  const throttledOnScroll = useThrottleFrame(onScroll)
  useEventListener(window, 'scroll', throttledOnScroll, { passive: true })
  throttledOnScroll()
})

watch(isBreakpointMd, () => onScroll())
</script>
